<template>
    <vx-card>
        <main class="mb-6 w-full">
          <section class="mb-2 flex justify-start gap-1">
            <h6><strong>Edit Term and Condition</strong></h6>
            <span class="text-danger">*</span>
          </section>
          <quill-editor 
          v-model="valueText"></quill-editor>
        </main>
        <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl">Cancel</vs-button>
        <vs-button color="success" class="ml-2 rounded-2xl">{{
          labelButton
        }}</vs-button>
      </div>
    </footer>
    </vx-card>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
    components : {
        quillEditor
    },
    data : {
        valueText : ''
    },
    computed : {
        labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    }
}
</script>